import React from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha } from "../../../resources/Helper";
import SignatureCanvas from 'react-signature-canvas';
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";
import { generarPdfConTextoNativo } from '../../../utils/pdfHelpers';
import '../common/ModalEnviarEmail.css';

function ModalConsentimientos(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    
    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    /** Registro del historial cargado en el formulario (evolución: ver en editor antes de PDF) */
    const [consentimientoSeleccionado, setConsentimientoSeleccionado] = useState(null);
    const [modoVisualizacionHistorico, setModoVisualizacionHistorico] = useState(false);

    // Estados para controlar modales con React (como en ModalContraremisiones.js)
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    /** Config para jsPDF nativo (misma vía que evolución); la vista previa del modal sigue en HTML */
    const [pdfNativoConfigConsentimiento, setPdfNativoConfigConsentimiento] = useState(null);

    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    const [showModalEmailConsentimiento, setShowModalEmailConsentimiento] = useState(false);
    const [emailDestinoConsentimiento, setEmailDestinoConsentimiento] = useState('');
    const [enviandoEmailConsentimiento, setEnviandoEmailConsentimiento] = useState(false);

    const canvasRef = useRef(null);
    const canvasExpandedRef = useRef(null);
    const firmaSnapshotRef = useRef('');
    const [editorConsentimiento, setEditorConsentimiento] = useState(null);
    const [showModalFirmaAmpliada, setShowModalFirmaAmpliada] = useState(false);

    /** Área de dibujo más grande en pantalla; la exportación sigue siendo PNG vía toDataURL (PDF limita max-width). */
    const calcFirmaCanvasSize = () => {
        const maxW = 560;
        const minW = 300;
        const viewportW = typeof window !== 'undefined' ? window.innerWidth : maxW;
        const w = Math.min(Math.max(viewportW - 48, minW), maxW);
        const h = Math.max(Math.round(w * (220 / 560)), 180);
        return { width: w, height: h };
    };

    /** Canvas del modal ampliado (casi pantalla completa, estilo visores PDF). */
    const calcFirmaCanvasSizeExpanded = () => {
        const vw = typeof window !== 'undefined' ? window.innerWidth : 920;
        const vh = typeof window !== 'undefined' ? window.innerHeight : 600;
        const isMobile = vw < 768;
        const horizontalPad = isMobile ? 32 : 64;
        const verticalReserve = isMobile ? 200 : 240;
        const w = Math.min(Math.max(vw - horizontalPad, 320), 960);
        const h = Math.min(Math.max(vh - verticalReserve, 260), isMobile ? 380 : 480);
        return { width: w, height: h };
    };

    const [firmaCanvasSize, setFirmaCanvasSize] = useState(() => calcFirmaCanvasSize());
    const [firmaExpandedCanvasSize, setFirmaExpandedCanvasSize] = useState(() => calcFirmaCanvasSizeExpanded());

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {
        const syncFirmaCanvasSize = () => setFirmaCanvasSize(calcFirmaCanvasSize());
        window.addEventListener('orientationchange', syncFirmaCanvasSize);
        window.addEventListener('resize', syncFirmaCanvasSize);
        return () => {
            window.removeEventListener('orientationchange', syncFirmaCanvasSize);
            window.removeEventListener('resize', syncFirmaCanvasSize);
        };
    }, []);

    useEffect(() => {
        if (!showModalFirmaAmpliada) return undefined;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, [showModalFirmaAmpliada]);

    const copiarFirmaEntreCanvas = (origenRef, destinoRef) => {
        if (!origenRef?.current || !destinoRef?.current) return;
        destinoRef.current.clear();
        if (origenRef.current.isEmpty()) return;
        try {
            destinoRef.current.fromDataURL(origenRef.current.toDataURL('image/png'));
        } catch (err) {
            console.warn('No se pudo copiar la firma entre canvas:', err);
        }
    };

    const abrirFirmaAmpliada = () => {
        if (modoVisualizacionHistorico) return;
        setFirmaExpandedCanvasSize(calcFirmaCanvasSizeExpanded());
        firmaSnapshotRef.current = canvasRef.current && !canvasRef.current.isEmpty()
            ? canvasRef.current.toDataURL('image/png')
            : '';
        setShowModalFirmaAmpliada(true);
        setTimeout(() => {
            if (!canvasExpandedRef.current) return;
            canvasExpandedRef.current.clear();
            if (firmaSnapshotRef.current) {
                try {
                    canvasExpandedRef.current.fromDataURL(firmaSnapshotRef.current);
                } catch (err) {
                    console.warn('No se pudo cargar firma en canvas ampliado:', err);
                }
            }
        }, 120);
    };

    const aplicarFirmaAmpliada = () => {
        copiarFirmaEntreCanvas(canvasExpandedRef, canvasRef);
        setShowModalFirmaAmpliada(false);
    };

    const cancelarFirmaAmpliada = () => {
        if (canvasRef.current) {
            canvasRef.current.clear();
            if (firmaSnapshotRef.current) {
                try {
                    canvasRef.current.fromDataURL(firmaSnapshotRef.current);
                } catch (err) {
                    console.warn('No se pudo restaurar firma:', err);
                }
            }
        }
        setShowModalFirmaAmpliada(false);
    };

    const limpiarFirmaPaciente = () => {
        if (canvasRef.current) canvasRef.current.clear();
        if (canvasExpandedRef.current) canvasExpandedRef.current.clear();
    };

    const limpiarFirmaAmpliada = () => {
        if (canvasExpandedRef.current) canvasExpandedRef.current.clear();
    };

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico ?? '');
                    setCodigoHabilitacion(response.data.codigo_habilitacion ?? '');
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/plantillas-consentimientos', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });
        
    },[]);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    /**
     * Firma del paciente: separador + título (sin banda gris), alineado con Otros Documentos.
     * Sin trazo: línea para firmar en físico.
     */
    const htmlFirmaPacienteBloque = (firmaSrc, pieTextoPlano) => {
        const pieHtml = pieTextoPlano
            ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line; text-transform: uppercase;">${pieTextoPlano}</div>`
            : '<div style="font-size: 13px; color: #adb5bd;">&nbsp;</div>';
        const celdaFirma = firmaSrc
            ? `<img src="${firmaSrc}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />`
            : `<div style="min-width: 140px; min-height: 64px; border-bottom: 1px solid #adb5bd;"></div>`;
        return `
                <div style="height: 1px; background-color: #e9ecef; margin: 24px 0 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 12px; margin-bottom: 16px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del paciente
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieHtml}</div>
                        <div style="flex-shrink: 0;">${celdaFirma}</div>
                    </div>
                </div>`;
    };

    const htmlFirmaProfesionalDesdeItem = (item) => {
        if (!item.profesional || !item.firma_final) return '';
        const pieFirmaHtml = item.texto_pie_firma_usuario
            ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
            : `<div style="font-size: 13px; color: #6c757d; line-height: 1.45;">
                    <strong>${item.profesional}</strong><br/>
                    RM: ${item.registro_medico || 'N/A'} | Habilitación: ${item.codigo_habilitacion || 'N/A'}
                  </div>`;
        return `
                <div style="height: 1px; background-color: #e9ecef; margin: 16px 0 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 12px; margin-bottom: 28px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del profesional
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieFirmaHtml}</div>
                        <div style="flex-shrink: 0;">
                            <img src="${item.firma_final}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />
                        </div>
                    </div>
                </div>`;
    };

    const piePacienteDesdeProps = () => {
        if (!props.paciente) return '';
        const n = `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim();
        const d = props.paciente.tipoDocumento && props.paciente.numeroDocumento
            ? `${props.paciente.tipoDocumento} - ${props.paciente.numeroDocumento}`
            : (props.paciente.numeroDocumento || '');
        return [n, d].filter(Boolean).join('\n');
    };

    const cargaritems = () => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        console.log('DEBUG Frontend - Enviando request con params:', JSON.stringify(config2.params)); // ✅ DEBUG mejorado

        return axios.get('/consentimientos', config2)
            .then(response => {
                console.log('Consentimientos Cargados:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 🎨 FORMATO TABLA CON BANDAS GRISES

                    // 1. Tabla de información básica (Fecha)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de contenido del consentimiento
                    let segmentoContenido = '';
                    if (item.contenido) {
                        segmentoContenido = `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CONSENTIMIENTO INFORMADO</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <style type="text/css">
                                                    .consentimiento-preview-rich,
                                                    .consentimiento-preview-rich * {
                                                        white-space: normal;
                                                        overflow-wrap: anywhere;
                                                        word-break: break-word;
                                                    }
                                                </style>
                                                <div class="consentimiento-preview-rich">${item.contenido}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 3. Firma del paciente (misma banda gris con o sin trazo)
                    const segmentoFirmaPaciente = htmlFirmaPacienteBloque(item.firma_paciente || '', piePacienteDesdeProps());

                    // 4. Solo firma del profesional (RM/habilitación van en el pie de firma o imagen)
                    const segmentoProfesional = `
                        <div style="margin-bottom: 12px;">
                            ${htmlFirmaProfesionalDesdeItem(item)}
                        </div>`;

                    // 5. Separador entre consentimientos
                    let separadorConsentimientos = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const itemParcial = segmentoCabecera + segmentoContenido + segmentoFirmaPaciente + segmentoProfesional + separadorConsentimientos;

                    consolidadoItems += itemParcial;
                    return null;
                });

                setConsolidado(consolidadoItems);
                return response.data;
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    }



    const contenidoHandler = (event, editor) => {
        if (modoVisualizacionHistorico) return;
        setContenido(editor.getData());
    };

    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const formatearFechaHoraParaMostrar = (valor) => {
        if (!valor) return '';
        if (typeof valor === 'string' && valor.includes('T')) {
            const [fecha, hora] = valor.split('T');
            return `${fecha} ${hora}`;
        }
        const d = valor instanceof Date ? valor : new Date(valor);
        if (Number.isNaN(d.getTime())) return String(valor);
        return d.toLocaleString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    };

    const establecerFechaHoraActual = () => {
        setFechaHora(formatearFechaHoraParaInput(new Date()));
    };

    const handleSubmit = (e) => {
        
        e.preventDefault();

        if (modoVisualizacionHistorico) {
            return;
        }

        if (deshabilitarBotonGuardar || loading) {
            return;
        }

        if (!fechaHora || !String(fechaHora).trim()) {
            alert('La fecha y hora son obligatorias.');
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora,
            firma_paciente: ''
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        if (canvasRef.current && !canvasRef.current.isEmpty()) {
            data.firma_paciente = canvasRef.current.toDataURL('image/png');
        }
        
        axios.post('/consentimiento', data, config)
            .then(async (response) => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                props.guardarCambios('El Consentimiento Informado Ha Sido Guardado con Exito en la Historia del Paciente');

                const nuevoId = response.data?.id;
                const items = await cargaritems();
                const registroGuardado = nuevoId
                    ? items.find((item) => Number(item.id) === Number(nuevoId))
                    : items[0];

                if (registroGuardado) {
                    cargarConsentimientoHistorico(registroGuardado);
                } else {
                    nuevoConsentimiento();
                }
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                console.log('Error Guardando el Consentimiento, Intenta Nuevamente:', error);
                const data = error.response && error.response.data;
                if (data && data.detail) {
                    console.error('Detalle servidor (consentimiento):', data.detail);
                }
                if (data && data.message) {
                    console.error('Mensaje servidor:', data.message);
                }
                if (data && data.errors) {
                    setErrorlist(data.errors);
                } else {
                    setErrorlist({});
                }
            })
            
    }


    /** HTML único para modal/PDF (misma fuente que los datos mostrados en el formulario cuando aplica) */
    const construirHtmlResumenConsentimiento = (resumenIndividual) => {
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente No Identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento No Disponible';

        const celdaEtiqueta = 'background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;';
        const celdaValor = 'background-color: #f8f9fa; padding: 8px 12px; border: 1px solid #dee2e6;';

        const tablaUnificada = `
            <div style="margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="${celdaEtiqueta}">PACIENTE</td>
                            <td style="${celdaValor}">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DOCUMENTO</td>
                            <td style="${celdaValor}">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">FECHA Y HORA</td>
                            <td style="${celdaValor}">${resumenIndividual.fecha || ''}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const tituloCentrado = `
            <div style="margin: 8px 0 14px; text-align: center; font-weight: bold; font-size: 15px; color: #212529; letter-spacing: 0.02em;">
                CONSENTIMIENTO INFORMADO
            </div>`;

        const cuerpoVistaConsent = (resumenIndividual.contenido && String(resumenIndividual.contenido).trim())
            ? resumenIndividual.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueContenido = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 13px; line-height: 1.45;">
                    <style type="text/css">
                        .consentimiento-preview-rich,
                        .consentimiento-preview-rich * {
                            white-space: normal;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        }
                    </style>
                    <div class="consentimiento-preview-rich">${cuerpoVistaConsent}</div>
                </div>
            </div>`;

        const piePacienteResumen = [nombreCompleto, documentoCompleto].filter(Boolean).join('\n');
        const tablaFirmaPaciente = htmlFirmaPacienteBloque(resumenIndividual.firma_paciente || '', piePacienteResumen);

        const itemProfResumen = {
            ...resumenIndividual,
            firma_final: resumenIndividual.firma_final || resumenIndividual.firma
        };
        const tablaProfesional = htmlFirmaProfesionalDesdeItem(itemProfResumen);

        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';

        // Orden alineado con PDF nativo: encabezado → tabla gris → título → contenido → firmas
        return encabezadoPrev + tablaUnificada + tituloCentrado + bloqueContenido + tablaFirmaPaciente + tablaProfesional;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return {
                nombreCompleto: 'Paciente no identificado',
                documentoCompleto: '—'
            };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /**
     * PDF nativo alineado con la vista previa: una sola tabla gris + título + contenido + firmas.
     */
    const construirConfigPdfConsentimientoNativo = (payload) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `consentimiento-informado-${slug}.pdf`,
            paciente: {
                nombreCompleto,
                documentoCompleto
            },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };

        const gris = [248, 249, 250];
        config.secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'PACIENTE', valor: nombreCompleto },
                    { etiqueta: 'DOCUMENTO', valor: documentoCompleto },
                    { etiqueta: 'FECHA Y HORA', valor: String(payload.fecha || '') },
                ]
            },
            estilos: {
                bodyStyles: { fillColor: gris },
                alternateRowStyles: { fillColor: gris },
                columnStyles: {
                    0: { cellWidth: 52, fontStyle: 'bold', fillColor: gris },
                    1: { cellWidth: 'auto', fillColor: gris },
                },
            },
        });

        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'CONSENTIMIENTO INFORMADO',
            estilos: {
                alineacion: 'center',
                fontSize: 12,
                margenSuperiorMm: 4,
                espacioDespuesMm: 6,
            },
        });

        const cuerpoConsentPdf = (payload.contenido && String(payload.contenido).trim())
            ? payload.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        config.secciones.push({
            tipo: 'texto',
            contenido: cuerpoConsentPdf,
            estilos: { margenSuperiorMm: 1 },
        });

        const firmasGrupo = [];
        // Misma orden que la vista previa: paciente → profesional
        firmasGrupo.push({
            imagenBase64: payload.firma_paciente || '',
            metadata: {
                tipo: 'paciente',
                nombrePaciente: nombreCompleto,
                documentoPaciente: documentoCompleto
            }
        });

        const firmaProfesionalSrc = payload.firma_final || payload.firma;
        if (firmaProfesionalSrc) {
            const metaProf = payload.texto_pie_firma_usuario
                ? { tipo: 'profesional', textoPieFirma: payload.texto_pie_firma_usuario }
                : {
                    tipo: 'profesional',
                    nombre: payload.profesional || '',
                    registroMedico: payload.registro_medico || 'N/A',
                    codigoHabilitacion: payload.codigo_habilitacion || 'N/A'
                  };
            firmasGrupo.push({
                imagenBase64: firmaProfesionalSrc,
                metadata: metaProf
            });
        }

        const firmasConImagen = firmasGrupo.filter((f) => f.imagenBase64 || (f.metadata && f.metadata.tipo === 'paciente'));
        if (firmasConImagen.length > 0) {
            config.secciones.push({
                tipo: 'firmas-grupo',
                firmas: firmasConImagen,
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: true,
                    separadorCadaFirma: true,
                },
            });
        }

        return config;
    };

    const cargarConsentimientoHistorico = (item) => {
        setConsentimientoSeleccionado(item);
        setModoVisualizacionHistorico(true);
        setContenido(item.contenido || '');
        setErrorlist({});

        setTimeout(() => {
            if (!canvasRef.current) return;
            canvasRef.current.clear();
            if (item.firma_paciente) {
                try {
                    canvasRef.current.fromDataURL(item.firma_paciente);
                } catch (err) {
                    console.warn('No se pudo cargar firma del paciente en canvas:', err);
                }
            }
        }, 150);
    };

    const nuevoConsentimiento = () => {
        setConsentimientoSeleccionado(null);
        setModoVisualizacionHistorico(false);
        setContenido('');
        setErrorlist({});
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
        const sel = document.getElementById('plantillas');
        if (sel) sel.value = '';
    };

    /** Payload del consentimiento actual (histórico seleccionado o borrador en formulario) */
    const construirPayloadConsentimientoActual = () => {
        if (modoVisualizacionHistorico && consentimientoSeleccionado) {
            return {
                fecha: consentimientoSeleccionado.fecha,
                contenido: contenido,
                firma_paciente: consentimientoSeleccionado.firma_paciente || (canvasRef.current && !canvasRef.current.isEmpty() ? canvasRef.current.toDataURL('image/png') : ''),
                profesional: consentimientoSeleccionado.profesional,
                registro_medico: consentimientoSeleccionado.registro_medico,
                codigo_habilitacion: consentimientoSeleccionado.codigo_habilitacion,
                firma: consentimientoSeleccionado.firma,
                firma_final: consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma,
                texto_pie_firma_usuario: consentimientoSeleccionado.texto_pie_firma_usuario
            };
        }

        return {
            fecha: formatearFechaHoraParaMostrar(fechaHora || new Date()),
            contenido: contenido,
            firma_paciente: canvasRef.current && !canvasRef.current.isEmpty() ? canvasRef.current.toDataURL('image/png') : '',
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            firma: firmaimg,
            firma_final: firmaimg,
            texto_pie_firma_usuario: textoPieFirma || ''
        };
    };

    const blobPdfToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                if (!result || typeof result !== 'string') {
                    reject(new Error('No se pudo leer el PDF generado'));
                    return;
                }
                resolve(result.split(',')[1]);
            };
            reader.onerror = () => reject(new Error('Error al convertir el PDF'));
            reader.readAsDataURL(blob);
        });

    const abrirModalEmailConsentimiento = () => {
        const payload = construirPayloadConsentimientoActual();
        if (!payload?.contenido || !String(payload.contenido).trim()) {
            alert('No hay contenido de consentimiento para enviar por correo.');
            return;
        }

        setEmailDestinoConsentimiento((props.paciente?.email || '').trim());
        setShowModalEmailConsentimiento(true);
    };

    const enviarConsentimientoPorEmail = async () => {
        const email = (emailDestinoConsentimiento || '').trim();
        if (!email) {
            alert('Por favor ingrese un correo electrónico válido.');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Por favor ingrese un correo electrónico válido.');
            return;
        }

        const payload = construirPayloadConsentimientoActual();
        const config = construirConfigPdfConsentimientoNativo(payload);
        if (!config || !payload?.contenido || !String(payload.contenido).trim()) {
            alert('No hay contenido disponible para enviar por correo.');
            return;
        }

        try {
            setEnviandoEmailConsentimiento(true);
            setShowModalEmailConsentimiento(false);

            const pdf = await generarPdfConTextoNativo(config);
            const pdfBlob = pdf.output('blob');
            const base64data = await blobPdfToBase64(pdfBlob);

            await axios.post('/enviar-historia-clinica-email', {
                paciente_id: pacienteId,
                email_destino: email,
                pdf_base64: base64data,
                nombre_archivo: config.filename,
                titulo_documento: `Consentimiento informado - ${payload.fecha || ''}`.trim(),
                nombre_profesional: String(payload.profesional || '').trim() || null
            });

            alert(`Consentimiento informado enviado exitosamente a ${email}`);
        } catch (error) {
            console.error('Error enviando consentimiento por email:', error.response?.data || error);
            const mensaje =
                error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                'Error desconocido';
            alert('Error al enviar el consentimiento por email: ' + mensaje);
        } finally {
            setEnviandoEmailConsentimiento(false);
        }
    };

    /** Vista previa / PDF desde el estado actual del formulario (incluye borrador nuevo o registro histórico cargado) */
    const abrirVistaImpresionDesdeFormulario = () => {
        const payload = construirPayloadConsentimientoActual();
        setTituloResumen('Consentimiento Informado');
        setContenidoResumenIndividual(construirHtmlResumenConsentimiento(payload));
        setPdfNativoConfigConsentimiento(construirConfigPdfConsentimientoNativo(payload));
        setShowModalResumen(true);
    };

    
    useEffect(() => {
        cargaritems();
    },[props.cargarHistorial]);

    useEffect(() => {
        if (!editorConsentimiento) return;
        try {
            if (typeof editorConsentimiento.enableReadOnlyMode === 'function') {
                if (modoVisualizacionHistorico) {
                    editorConsentimiento.enableReadOnlyMode('modal-consentimiento-hist');
                } else {
                    editorConsentimiento.disableReadOnlyMode('modal-consentimiento-hist');
                }
            } else {
                editorConsentimiento.isReadOnly = modoVisualizacionHistorico;
            }
        } catch (e) {
            console.warn('CKEditor readOnly:', e);
        }
    }, [modoVisualizacionHistorico, editorConsentimiento]);

    // ✅ AGREGADO: Cleanup cuando se cierran los modales (como en ModalContraremisiones.js)
    useEffect(() => {
        return () => {
            setShowModalResumen(false);
            setShowModalConsolidado(false);
        };
    }, []);


    const descargarPdf = () => {
        
        var opt = {
            margin:       12,
            filename:     `consentimientos.pdf`,
            image:        { type: 'jpeg', quality: 0.97 },
            html2canvas:  { scale: 2, useCORS: true, allowTaint: true },
            jsPDF:        { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let consentimientosCompleto = "<img src='"+logoImg+"' class='app-logo-pdf' /><h1 class='ttl-pdf'>CONSENTIMIENTOS INFORMADOS</h1>"+anamnesis+"<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(consentimientosCompleto,opt);
    }


    const handleContenido = (contenidoPlantilla) => {

        let nombreCompletoPaciente = props.paciente.primerNombre + ' ' + (props.paciente.segundoNombre ? props.paciente.segundoNombre + ' ' : '') + props.paciente.primerApellido + ' ' + (props.paciente.segundoApellido ? props.paciente.segundoApellido : '');
        const refFecha = fechaHora ? new Date(fechaHora) : new Date();

        contenidoPlantilla = contenidoPlantilla.replace("{{nombre}}",nombreCompletoPaciente);
        contenidoPlantilla = contenidoPlantilla.replace("{{numero_documento}}",props.paciente.numeroDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{tipo_documento}}",props.paciente.tipoDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{fecha}}", refFecha.getDate() + '/' + (refFecha.getMonth() + 1) + '/' + refFecha.getFullYear());

        setContenido(contenidoPlantilla);
    }


    if (loggedIn) {
        return (
            
                <>
                    <style>{`
                        /* Espaciado alineado con vista previa / PDF (párrafos y títulos del editor) */
                        .consentimientos-editor .ck-editor__editable p {
                            margin: 0 0 0.9em 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable p:last-child {
                            margin-bottom: 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable h1,
                        .consentimientos-editor .ck-editor__editable h2,
                        .consentimientos-editor .ck-editor__editable h3,
                        .consentimientos-editor .ck-editor__editable h4 {
                            margin: 1em 0 0.5em 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable > *:first-child {
                            margin-top: 0 !important;
                        }
                        .consentimiento-firma-paciente-wrap {
                            width: 100%;
                            max-width: 560px;
                            position: relative;
                        }
                        .consentimiento-firma-paciente-wrap canvas.consentimiento-firma-paciente-canvas {
                            display: block;
                            width: 100%;
                            max-width: 100%;
                            border: 1px solid #c4c4c4;
                            border-radius: 8px;
                            background: #fff;
                            touch-action: none;
                            cursor: crosshair;
                        }
                        .consentimiento-firma-expand-btn {
                            position: absolute;
                            top: 8px;
                            right: 8px;
                            z-index: 2;
                            width: 36px;
                            height: 36px;
                            border: 1px solid #ced4da;
                            border-radius: 8px;
                            background: rgba(255, 255, 255, 0.95);
                            color: #495057;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
                            cursor: pointer;
                        }
                        .consentimiento-firma-expand-btn:hover {
                            background: #f8f9fa;
                            color: #17a2b8;
                            border-color: #17a2b8;
                        }
                        .consentimiento-firma-expand-dialog {
                            max-width: min(980px, 96vw);
                        }
                        .consentimiento-firma-expand-content {
                            border: none;
                            border-radius: 14px;
                            overflow: hidden;
                        }
                        .consentimiento-firma-expand-head {
                            background: #323a45;
                            color: #fff;
                            border-bottom: none;
                            padding: 14px 18px;
                        }
                        .consentimiento-firma-expand-head .close {
                            color: #fff;
                            opacity: 0.85;
                            text-shadow: none;
                        }
                        .consentimiento-firma-expand-body {
                            background: #eef1f4;
                            padding: 18px;
                        }
                        .consentimiento-firma-expand-canvas-wrap {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: #fff;
                            border: 2px dashed #adb5bd;
                            border-radius: 12px;
                            padding: 12px;
                            min-height: 280px;
                        }
                        .consentimiento-firma-expand-canvas-wrap canvas {
                            display: block;
                            max-width: 100%;
                            border: 1px solid #dee2e6;
                            border-radius: 8px;
                            background: #fff;
                            touch-action: none;
                            cursor: crosshair;
                        }
                        .consentimiento-firma-expand-hint {
                            font-size: 0.82rem;
                            color: #6c757d;
                            margin-bottom: 12px;
                        }
                        .consentimiento-firma-expand-footer {
                            background: #fff;
                            border-top: 1px solid #dee2e6;
                            padding: 12px 18px;
                        }
                        @media (max-width: 576px) {
                            .consentimiento-firma-paciente-wrap {
                                max-width: 100%;
                            }
                        }
                        .consentimiento-seccion-label {
                            display: block;
                            font-size: 0.85rem;
                            font-weight: 700;
                            color: #323a45;
                            margin-bottom: 8px;
                        }
                    `}</style>
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-9">

                                    <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom">
                                            <div className="d-flex flex-wrap align-items-center mb-1 mb-md-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-dark mr-2 mb-1"
                                                    onClick={abrirVistaImpresionDesdeFormulario}
                                                    title="Abrir vista previa e imprimir o descargar PDF"
                                                >
                                                    <i className="fas fa-file-pdf mr-1"></i> Vista previa / PDF
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-info mr-2 mb-1"
                                                    onClick={abrirModalEmailConsentimiento}
                                                    disabled={enviandoEmailConsentimiento || !String(contenido || '').trim()}
                                                    title="Enviar este consentimiento por correo electrónico"
                                                >
                                                    {enviandoEmailConsentimiento ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                            Enviando...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-envelope mr-1"></i> Email
                                                        </>
                                                    )}
                                                </button>
                                                {modoVisualizacionHistorico && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary mb-1"
                                                        onClick={nuevoConsentimiento}
                                                        title="Limpiar formulario para un consentimiento nuevo"
                                                    >
                                                        <i className="fas fa-plus mr-1"></i> Nuevo consentimiento
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {modoVisualizacionHistorico && consentimientoSeleccionado && (
                                            <div className="alert alert-secondary py-2 mb-3" role="status">
                                                <i className="fas fa-history mr-2"></i>
                                                Viendo consentimiento del <strong>{consentimientoSeleccionado.fecha}</strong>. Puede enviarlo por email o abrir la vista previa / PDF.
                                            </div>
                                        )}

                                        <div id="historiageneral">
                                            <div className="row">
                                                {!modoVisualizacionHistorico && (
                                                    <div className="col-md-12">
                                                        <label className="consentimiento-seccion-label">Fecha y Hora *</label>
                                                        <div className="form-group mb-3">
                                                            <div className="input-group">
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control"
                                                                    required
                                                                    value={fechaHora || ''}
                                                                    onChange={(e) => setFechaHora(e.target.value)}
                                                                />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-dark" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-md-12">
                                                    <label className="consentimiento-seccion-label">Seleccione La Plantilla o Digite Su Contenido</label>
                                                    

                                                    <div className="form-group">
                                                        <select name="plantillas" className="form-control" id="plantillas" disabled={modoVisualizacionHistorico} onChange={(e) => handleContenido(e.target.value)} >
                                                            <option value="">Seleccionar Plantilla...</option>
                                                            {
                                                                plantillas.map((plantilla) => 
                                                                    <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            onReady={(editor) => setEditorConsentimiento(editor)}
                                                            onChange={contenidoHandler}
                                                            data={contenido}
                                                        />
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.contenido}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label>Firma del paciente <span className="text-muted font-weight-normal">(opcional)</span></label>
                                                    <small className="d-block text-muted mb-1">
                                                        Puede guardar sin firma y entregar el documento impreso para que el paciente firme después.
                                                        {!modoVisualizacionHistorico && (
                                                            <> Use <strong>Ampliar</strong> para firmar en un recuadro más grande (como en visores PDF).</>
                                                        )}
                                                    </small>
                                                    <div
                                                        className="consentimiento-firma-paciente-wrap"
                                                        style={modoVisualizacionHistorico ? { pointerEvents: 'none', opacity: 0.95 } : undefined}
                                                    >
                                                        {!modoVisualizacionHistorico && (
                                                            <button
                                                                type="button"
                                                                className="consentimiento-firma-expand-btn"
                                                                onClick={abrirFirmaAmpliada}
                                                                title="Ampliar área de firma"
                                                                aria-label="Ampliar área de firma"
                                                            >
                                                                <i className="fas fa-expand"></i>
                                                            </button>
                                                        )}
                                                        <SignatureCanvas
                                                            ref={canvasRef}
                                                            penColor="#242424"
                                                            minWidth={1.2}
                                                            maxWidth={2.8}
                                                            canvasProps={{
                                                                width: firmaCanvasSize.width,
                                                                height: firmaCanvasSize.height,
                                                                className: 'sigCanvas consentimiento-firma-paciente-canvas',
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="mt-2 d-flex flex-wrap align-items-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm mr-2 mb-1"
                                                            disabled={modoVisualizacionHistorico}
                                                            onClick={(e) => { e.preventDefault(); limpiarFirmaPaciente(); }}
                                                        >
                                                            <i className="fas fa-eraser"></i> Borrar
                                                        </button>
                                                        {!modoVisualizacionHistorico && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-info btn-sm mb-1"
                                                                onClick={(e) => { e.preventDefault(); abrirFirmaAmpliada(); }}
                                                            >
                                                                <i className="fas fa-expand-arrows-alt mr-1"></i> Ampliar
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.firma_paciente}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div id="profesional-atiende">
                                                <div className="card-body" style={{padding: '0.7rem'}}>
                                                    <div className="row">
                                                        {(modoVisualizacionHistorico && consentimientoSeleccionado
                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                            : firmaimg) && (
                                                            <div className="col-md-4">
                                                                <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                    <label>Firma del profesional</label>
                                                                    <br></br>
                                                                    <img
                                                                        src={modoVisualizacionHistorico && consentimientoSeleccionado
                                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                                            : firmaimg}
                                                                        className="firma-profesional-hc"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className={(modoVisualizacionHistorico && consentimientoSeleccionado
                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                            : firmaimg) ? 'col-md-8' : 'col-md-12'}>
                                                            <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                <label>Pie de firma</label>
                                                                <br></br>
                                                                {(modoVisualizacionHistorico && consentimientoSeleccionado && consentimientoSeleccionado.texto_pie_firma_usuario) ? (
                                                                    <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                        {consentimientoSeleccionado.texto_pie_firma_usuario}
                                                                    </div>
                                                                ) : textoPieFirma ? (
                                                                    <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                        {textoPieFirma}
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                        {modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.profesional : nombreProfesional}
                                                                        <br />
                                                                        <small>
                                                                            RM: {(modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.registro_medico : registroMedico) || 'N/A'}
                                                                            {' '}| Hab: {(modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.codigo_habilitacion : codigoHabilitacion) || 'N/A'}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        <div className="row">
                                            <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                <button type="submit" className="btn btn-secondary mb-2 mb-sm-0 mr-2" disabled={deshabilitarBotonGuardar || modoVisualizacionHistorico}>
                                                    Guardar&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                </button>
                                                <a href="#" className="btn btn-outline-secondary mb-2 mb-sm-0" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</a>
                                            </div>
                                        </div>

                                        
                                    
                                    </form>
                                
        
                                </div>
                                <div className="col-md-3">
                                    
                                    
                                    
                                    <div className="timeline-evolucion">

                                        <b className="titulo-historial">Historial</b>

                                        {

                                            historial.map((item) => 
                                                
                                                    <div
                                                        key={item.id}
                                                        className="timeline-item-container"
                                                        onClick={() => cargarConsentimientoHistorico(item)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            ...(consentimientoSeleccionado && consentimientoSeleccionado.id === item.id
                                                                ? { backgroundColor: 'rgba(23, 162, 184, 0.12)', borderRadius: '8px', padding: '4px 6px' }
                                                                : {})
                                                        }}
                                                    >
                                                        <div className="timeline-punto-container"><div className="timeline-punto" style={consentimientoSeleccionado && consentimientoSeleccionado.id === item.id ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8' } : undefined}></div></div>
                                                        <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                                    </div>
                                                )
                                        }

                                    </div>

                                    {/*
                                      Resumen consolidado (todos los consentimientos): oculto a propósito.
                                      La impresión/PDF de ese HTML suele salir como imagen (html2canvas) con errores.
                                      El historial ya permite abrir cada registro con vista previa/PDF por documento.
                                    <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Resumen</button>
                                    <br />
                                    <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>
                                    */}

                                </div>
                            
                            </div>
                            
                        </div>
                    </section>

                {/* ✅ MODALES CON REACT STATE (como en ModalRemisiones.js) */}
                {showModalResumen && (
                    <ModalResumenRemision 
                        idModal="modalResumenConsentimientos"
                        titulo={tituloResumen} 
                        contenido={contenidoResumenIndividual} 
                        profesional={profesionalResumenIndividual} 
                        registro={registroMedicoResumenIndividual} 
                        codigo={codigoHabilitacionResumenIndividual} 
                        firma={firmaResumenIndividual}
                        paciente={props.paciente}
                        tipoArchivo={'consentimiento-informado'}
                        cliente={client}
                        docPaciente={props.docPaciente || props.paciente?.numeroDocumento}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        pdfNativoConfig={pdfNativoConfigConsentimiento}
                        onEnviarEmail={abrirModalEmailConsentimiento}
                        enviandoEmail={enviandoEmailConsentimiento}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigConsentimiento(null);
                        }}
                    />
                )}

                <Modal
                    show={showModalEmailConsentimiento}
                    onHide={() => !enviandoEmailConsentimiento && setShowModalEmailConsentimiento(false)}
                    centered
                    dialogClassName="mx-email-dialog"
                    contentClassName="mx-email-content"
                >
                    <Modal.Header closeButton className="mx-email-head">
                        <Modal.Title>
                            <span className="mx-email-head-icon">
                                <i className="fas fa-envelope"></i>
                            </span>
                            Enviar Consentimiento por Email
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="mx-email-body">
                        <div className="mx-email-info">
                            <i className="fas fa-info-circle"></i>
                            <div className="mx-email-info-text">
                                <span className="mx-email-info-desc">
                                    Se enviará el consentimiento informado
                                    {consentimientoSeleccionado?.fecha ? (
                                        <> del <strong>{consentimientoSeleccionado.fecha}</strong></>
                                    ) : null}
                                    {' '}en PDF.
                                </span>
                                {(() => {
                                    const prof = construirPayloadConsentimientoActual()?.profesional;
                                    return prof ? (
                                        <span className="mx-email-info-prof">
                                            Profesional: {prof}
                                        </span>
                                    ) : null;
                                })()}
                            </div>
                        </div>
                        <label className="mx-email-label" htmlFor="emailDestinoConsentimiento">
                            Correo electrónico de destino <span className="text-danger">*</span>
                        </label>
                        <div className="mx-email-input-wrap">
                            <input
                                id="emailDestinoConsentimiento"
                                type="email"
                                className={`mx-email-input${emailDestinoConsentimiento.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailDestinoConsentimiento.trim()) ? ' is-invalid' : ''}`}
                                value={emailDestinoConsentimiento}
                                onChange={(e) => setEmailDestinoConsentimiento(e.target.value)}
                                placeholder="ejemplo@correo.com"
                                autoFocus
                                disabled={enviandoEmailConsentimiento}
                            />
                            <span className={`mx-email-input-icon${/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((emailDestinoConsentimiento || '').trim()) ? ' is-valid' : ''}`}>
                                {/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((emailDestinoConsentimiento || '').trim())
                                    ? <i className="fas fa-check-circle"></i>
                                    : <i className="fas fa-envelope"></i>}
                            </span>
                        </div>
                        <small className="mx-email-help">
                            Por defecto se usa el correo del paciente; puede cambiarlo si es necesario.
                        </small>
                    </Modal.Body>
                    <Modal.Footer className="mx-email-footer">
                        <button
                            type="button"
                            className="mx-email-btn-cancel"
                            onClick={() => setShowModalEmailConsentimiento(false)}
                            disabled={enviandoEmailConsentimiento}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="mx-email-btn-send"
                            onClick={enviarConsentimientoPorEmail}
                            disabled={enviandoEmailConsentimiento}
                        >
                            {enviandoEmailConsentimiento ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                    Enviando...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane mr-1"></i> Enviar
                                </>
                            )}
                        </button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showModalFirmaAmpliada}
                    onHide={cancelarFirmaAmpliada}
                    centered
                    backdrop="static"
                    keyboard={false}
                    dialogClassName="consentimiento-firma-expand-dialog"
                    contentClassName="consentimiento-firma-expand-content"
                >
                    <Modal.Header closeButton className="consentimiento-firma-expand-head">
                        <Modal.Title className="d-flex align-items-center" style={{ fontSize: '1.05rem' }}>
                            <i className="fas fa-signature mr-2"></i>
                            Firmar aquí
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="consentimiento-firma-expand-body">
                        <p className="consentimiento-firma-expand-hint mb-0">
                            Dibuje la firma del paciente en el recuadro. En tablet o celular puede usar el dedo o un stylus.
                        </p>
                        <div className="consentimiento-firma-expand-canvas-wrap mt-2">
                            <SignatureCanvas
                                ref={canvasExpandedRef}
                                penColor="#242424"
                                minWidth={1.5}
                                maxWidth={3.2}
                                canvasProps={{
                                    width: firmaExpandedCanvasSize.width,
                                    height: firmaExpandedCanvasSize.height,
                                    className: 'sigCanvas consentimiento-firma-expand-canvas',
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="consentimiento-firma-expand-footer d-flex justify-content-between flex-wrap">
                        <Button variant="outline-secondary" onClick={limpiarFirmaAmpliada}>
                            <i className="fas fa-eraser mr-1"></i> Borrar
                        </Button>
                        <div className="d-flex flex-wrap">
                            <Button variant="light" className="mr-2 mb-1 mb-sm-0" onClick={cancelarFirmaAmpliada}>
                                Cancelar
                            </Button>
                            <Button variant="info" onClick={aplicarFirmaAmpliada}>
                                <i className="fas fa-check mr-1"></i> Aplicar firma
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/*
                  Modal consolidado deshabilitado junto al botón Resumen (ver comentario arriba).
                {showModalConsolidado && (
                    <ModalResumenRemision 
                        idModal="modalConsolidadoConsentimientos"
                        titulo="Resumen consentimientos informados" 
                        contenido={consolidado}
                        paciente={props.paciente}
                        tipoArchivo={'historico-consentimientos-informados'}
                        cliente={client}
                        pdfAltoContraste={true}
                        onClose={() => setShowModalConsolidado(false)}
                    />
                )}
                */}

                </>
                
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalConsentimientos;